import React from 'react';
import { Code, Database, Zap, Wrench, Shield, Headphones, Cloud, Server, TrendingUp, Search } from 'lucide-react';
import './Services.css';

const servicesData = [
  {
    icon: <Code size={40} />,
    title: 'White-Label Laravel Development',
    description: 'Complete Laravel solutions delivered under your brand with full NDA protection and confidentiality.',
    category: 'development'
  },
  {
    icon: <Database size={40} />,
    title: 'Custom SaaS & Web App Development',
    description: 'Scalable custom applications built with Laravel for enterprise-level performance and reliability.',
    category: 'development'
  },
  {
    icon: <Code size={40} />,
    title: 'React.js & Next.js Development',
    description: 'Modern frontend solutions with React.js and full-stack Next.js applications for optimal performance.',
    category: 'development'
  },
  {
    icon: <Zap size={40} />,
    title: 'API Development & Integrations',
    description: 'RESTful APIs, third-party integrations, and seamless connection between your systems.',
    category: 'development'
  },
  {
    icon: <Cloud size={40} />,
    title: 'Powerful Cloud Hosting',
    description: 'Managed VPS hosting powered by A2z Cloud starting at ₹220/month with guaranteed uptime.',
    category: 'cloud',
    highlight: true
  },
  {
    icon: <Server size={40} />,
    title: 'VPS Setup & Server Management',
    description: 'Complete server configuration, security hardening, automated backups, and performance optimization.',
    category: 'cloud'
  },
  {
    icon: <Shield size={40} />,
    title: 'Security & Monitoring Services',
    description: 'Malware scans, security checks, uptime monitoring, and proactive threat prevention.',
    category: 'cloud'
  },
  {
    icon: <TrendingUp size={40} />,
    title: 'Laravel App Deployment & Scaling',
    description: 'Zero-downtime deployment, auto-scaling, load balancing, and migration services.',
    category: 'cloud'
  },
  {
    icon: <Search size={40} />,
    title: 'SEO & Growth Services',
    description: 'Technical SEO, Core Web Vitals optimization, speed improvements, and website health monitoring.',
    category: 'seo'
  },
  {
    icon: <Headphones size={40} />,
    title: 'Long-Term Support & Maintenance',
    description: 'Ongoing white-label partnership with dedicated support, updates, and continuous improvements.',
    category: 'support'
  }
];

const Services = () => {
  return (
    <section className="services-section" id="services">
      <div className="services-container">
        <div className="services-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-description">
            Comprehensive development, hosting, and growth services for agencies and businesses
          </p>
        </div>
        
        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div key={index} className={`service-card ${service.highlight ? 'highlight' : ''}`}>
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              {service.highlight && <span className="service-badge">Popular</span>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;